/* src/app/modules/shared/components/dialogs/result-dialog/result-dialog.component.css */
/*# sourceMappingURL=result-dialog.component.css.map */
